module.exports = __webpack_public_path__ + "static/media/Slice29@2x.1da1d968.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice29@2x.png
// module id = 1458
// module chunks = 0